/* eslint-disable consistent-return */

import ChartCard from './ChartCard';

const ChartPreview = ({ chartPreviewData }: any) => {
  return <ChartCard chartData={chartPreviewData} isDashboardLayout={false} />;
};

export default ChartPreview;
